import { Component, Input, computed } from '@angular/core';

import { OddsFormatterService } from '@frontend/sports/odds/feature';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { PickOddsState, PickType } from '../../../core/picks/pick-models';
import { OverAskFlowState } from '../../../model/over-ask/over-ask';
import { SingleSlipType } from '../../bet-generation/slip-type';
import { IBetslipOverAskPickChangesProps, IBetslipOverAskPickComponentProps } from '../models/over-ask.model';

@Component({
    template: '',
    standalone: false,
})
export class BetslipOverAskPickSelectorBaseComponent {
    @Input() props: IBetslipOverAskPickComponentProps;
    @Input() overAskFlowState: OverAskFlowState;
    @Input() isMultiSingle = false;
    @Input() oddsDisplayFormat: OddsDisplayFormat;

    pickTypes: typeof PickType = PickType;
    oddStates: typeof PickOddsState = PickOddsState;

    getprice = computed(() =>
        this.oddsFormatterPipe.format(this.props.overAskPick.price.nativeOdds, {
            displayFormat: this.oddsDisplayFormat,
            cutZero: false,
            isSummary: true,
        }),
    );

    constructor(private oddsFormatterPipe: OddsFormatterService) {}

    canBetBeRemoved(): boolean {
        return (
            this.props.overAskBet.type instanceof SingleSlipType &&
            this.overAskFlowState === OverAskFlowState.Review &&
            this.props.overAskPick.oddsState === PickOddsState.Open &&
            this.isMultiSingle
        );
    }

    isPendingState(): boolean {
        return this.overAskFlowState === OverAskFlowState.Pending;
    }

    isReviewState(): boolean {
        return this.overAskFlowState === OverAskFlowState.Review;
    }

    isRemoved(): boolean {
        return this.props.overAskBet.isRemoved;
    }

    getPriceChangesProps(): IBetslipOverAskPickChangesProps {
        return {
            pickId: this.props.overAskPick.pick.id.toString(),
            betState: this.props.overAskBet,
            pickState: this.props.overAskPick.oddsState,
            overAskPickState: {
                initialPrice: this.props.overAskPick.price,
                counterOfferPrice: this.props.overAskPick.changes.price,
                isInitialEachWay: this.props.overAskPick.isEachWay,
                counterOfferMarketType: this.props.overAskPick.changes.marketType,
            },
        };
    }

    isClosedOrLocked(): boolean {
        return this.props.overAskPick.pick.oddsState === PickOddsState.Closed || this.props.overAskPick.pick.oddsState === PickOddsState.Locked;
    }
}
